import React from 'react';
import { Link } from 'react-router-dom';
import warehouse from '../assets/Warehousesmall.png';

const Warehouses = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Warehouse WiFi Solutions</h1>

        <img src={warehouse} alt="Warehouse WiFi" style={{
          width: '100%', maxWidth: '600px', borderRadius: '12px', marginBottom: '30px'
        }} />

        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>The Challenge</h2>
        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Warehouses present some of the most challenging RF environments for wireless connectivity.
          High ceilings, metal shelving, constantly moving inventory, and dense equipment create
          signal obstructions that standard office WiFi cannot handle. Yet modern warehouse operations
          depend heavily on wireless connectivity for barcode scanners, inventory management systems,
          automated guided vehicles, and IoT sensors.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Our Solution</h2>
        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Sarvanta delivers industrial-grade WiFi solutions specifically designed for warehouse
          environments. Our AI-powered radio management continuously adapts to changing conditions
          as inventory moves and equipment operates, maintaining reliable coverage throughout the
          entire facility.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '24px' }}>Key Capabilities</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginBottom: '40px' }}>
          {[
            { title: 'Full Facility Coverage', desc: 'Engineered access point placement and power management to eliminate dead zones in high-ceiling, high-density environments.' },
            { title: 'High-Bandwidth Operations', desc: 'Sufficient throughput for real-time inventory tracking, voice-over-WiFi, video surveillance, and fleet management systems.' },
            { title: 'Roaming Without Drops', desc: 'Seamless handoff between access points so mobile workers and AGVs stay connected as they move through the facility.' },
            { title: 'IoT Device Support', desc: 'Network segmentation and MAC-based authentication for barcode scanners, RFID readers, environmental sensors, and other IoT devices.' },
            { title: 'Centralized Management', desc: 'Monitor and manage WiFi across multiple warehouse locations from a single cloud dashboard with real-time alerts.' },
            { title: 'Cost-Effective Deployment', desc: 'Open hardware and zero-touch provisioning minimize both CapEx and OpEx while maintaining enterprise-grade reliability.' }
          ].map((item, i) => (
            <div key={i} style={{
              padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px',
              border: '1px solid #1a2744'
            }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', color: '#60a5fa' }}>{item.title}</h3>
              <p style={{ color: '#a0aec0', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>{item.desc}</p>
            </div>
          ))}
        </div>

        <div style={{ padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px', border: '1px solid #1a2744', textAlign: 'center' }}>
          <p style={{ color: '#a0aec0', marginBottom: '16px' }}>
            Learn how to implement reliable warehouse WiFi with our detailed white paper.
          </p>
          <Link to="/whitepapers" style={{
            padding: '12px 28px', backgroundColor: '#2563eb', color: '#fff',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '600'
          }}>Download White Paper</Link>
        </div>
      </div>
    </div>
  );
};

export default Warehouses;
